import React from "react";
import ResearchViewer from "../../containers/ResearchViewer";
import ResearchActivity from "../../containers/ResearchActivity";
import DesignChallenge from "../../containers/Journal/DesignChallenge";

const ResearchContent = ({ category }) => {
  switch (category) {
    case "lesson":
      return <ResearchViewer key="research-viewer" />;
    case "spec":
      return <DesignChallenge key="design-challenge" />;
    case "quiz":
    case "worksheet":
      return <ResearchActivity key="research-activity" />;
    case "tutorial":
    default:
      return <div key="watermark" className="box watermark" />;
  }
};

export default ResearchContent;
